if (!customElements.get("yc-button-variants")) {
  class ButtonVariants extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.handleClick.bind(this));
      this.productForm = document.querySelector(
        `form[id="${this.dataset.formId}"]`,
      );

      this.productField = this.productForm.querySelector(
        "input[name='product-id']",
      );
      this.variantField = this.productForm.querySelector("input[name='id']");
      this.submitButton = this.productForm.querySelector(
        "button[type='submit']",
      );

      // button click event
      this.buttons = this.querySelectorAll("button");
      this.buttons.forEach((button) => {
        button.addEventListener("click", this.handleClick.bind(this));
      });
      //console.log("ButtonVariants initialized");
    }

    handleClick(event) {
      const button = event.target.closest("button");
      if (button) {
        const productId = button.dataset.productId;
        const variantId = button.dataset.variantId;
        // console.log(`Product ID: ${productId}, Variant ID: ${variantId}`);

        this.variantField.value = variantId;
        this.productForm.querySelector("input[name='quantity']").value = 1;
        this.productField.value = productId;
        this.buttons.forEach((otherButton) => {
          otherButton.classList.remove("active");
        });
        this.classList.add("active");

        if (this.submitButton) {
          const variantPrice = button.dataset.variantPrice;

          /// check if submit button has sold-out class
          if (this.submitButton.classList.contains("out-of-stock")) {
            this.submitButton.removeAttribute("disabled");
            this.submitButton.classList.remove("out-of-stock");
            this.submitButton.querySelector(
              ".yc-product-card__button-label",
            ).innerHTML = "Add to cart";
          }

          this.submitButton.querySelector(".button-price").innerHTML =
            variantPrice;
        }
      }
    }
  }

  customElements.define("yc-button-variants", ButtonVariants);
}
